// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

import { Badge } from '@mantine/core';
import type { JSX } from 'react';

const STATUS_MAP: Record<string, { label: string; color: string }> = {
  draft: { label: 'Draft', color: 'gray' },
  active: { label: 'Submitted', color: 'green' },
  'entered-in-error': { label: 'Rejected', color: 'red' },
  cancelled: { label: 'Cancelled', color: 'orange' },
};

interface ClaimStatusBadgeProps {
  status: string | undefined;
}

export function ClaimStatusBadge({ status }: ClaimStatusBadgeProps): JSX.Element {
  const mapped = STATUS_MAP[status ?? ''] ?? { label: status ?? 'Unknown', color: 'gray' };
  return (
    <Badge color={mapped.color} variant="light" size="sm">
      {mapped.label}
    </Badge>
  );
}
